###
# filterSets              (object)    FilterSets.get(clientId) responce
# tables                  (array)     array of avaliable tables
# tableHasFilterSetMap    (object)    result ov FilterSets.buildTableHasFilterSetMap()
###
angular.module('rjmNg.directives').directive "filterSetsList", [
  () ->
    restrict: "E"
    templateUrl: "directive.filterSetsList.html"
    replace: true
    controllerAs: 'view'
    scope: {
      filterSets: '='
      tables: '='
      tableHasFilterSetMap: '='
    }
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$scope"
      "app"
      "logger"
      "FilterSets"
      "$url"
      "$routeParams"
      (
        $scope
        app
        logger
        FilterSets
        $url
        $routeParams
      ) ->

        view = @
        view.baseUrl = $url("")
        view.isAdmin = app.isAdminUser()
        view.isSupportUser = app.isSupportUserSession()
        view.clientId = $routeParams.clientId

        view.deleteFilterSet = (filterSetId) ->
          $scope.$emit('deleteFilterSet', filterSetId)

        view.editFilterSet = (filterSet) ->
          $scope.$emit('openUpdateFilterSetPage', filterSet)

        view.cloneFilterSet = (filterSet) ->
          $scope.$emit('openCloneFilterSetPage', filterSet)

        view.toggleAll = (expand) ->
          filterSet.expand = expand for filterSet in view.filterSets

        view.expand = (filterSet) ->
          filterSet.expand = !filterSet.expand

        view.hasFilterSet = (table) ->
          return view.tableHasFilterSetMap[table.id]

        view.inTable = (table) ->
          (filterSet) ->
            return filterSet.table_id is table.id

        logger.log('Filters Page Usage', 'Open', 1, 'list')

        return view
    ]
]
